import { v4 as uuidv4 } from 'uuid';

export const getProjectTemplateColumns = () => {
    const defaultStatusID = window.DEFAULT_STATUS_ID;
    const defaultWorkItemTypeListID = window.defaultWorkItemTypeListID;
    const defaultPriorityListID = window.defaultPriorityListID;
    const defaultSubModuleListID = window.defaultSubModuleListID;

    return [
    // Group 1 — Identity & Classification
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "#",
        "field": "#",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "pinned": "left", "sort": null, "sortIndex": null, "rowDrag": true
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "ag-Grid-AutoColumn",
        "field": "primaryCol",
        "headerName": "Work Area | Work Item",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
        "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
        "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null,
        "suppressMovable": true, "lockPosition": true
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 1",
        "field": "Column1",
        "headerName": "Sub Module",
        "type": "dropdownsingle",
        "width": "150",
        "filter": true, "editable": true,
        "sharedlistId": defaultSubModuleListID,
        "listItems": ["PR Dataset (Policies and Rules)",
            "MRT Dataset (Master, Reference and Transactional data)"],
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 2",
        "field": "Column2",
        "headerName": "Work Item Type",
        "type": "dropdownsingle",
        "width": "150",
        "filter": true, "editable": true,
        "sharedlistId": defaultWorkItemTypeListID,
        "listItems": ["Epic", "Feature", "User Story", "Task", "Bug", "Suggestion", "Spike", "Enhancement", "Area/Module"],
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 3",
        "field": "Column3",
        "headerName": "Priority",
        "type": "dropdownsingle",
        "width": "150",
        "filter": true, "editable": true,
        "sharedlistId": defaultPriorityListID,
        "listItems": ["Critical", "High", "Medium", "Low"],
    },
    // Group 2 — People & Status
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 4",
        "field": "Column4",
        "headerName": "Assignee",
        "type": "Assignee",
        "listData": "",
        "width": "150",
        "filter": true, "editable": true,
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 5",
        "field": "Column5",
        "type": "shareableRollupList",
        "cellDataType": "shareableRollupList",
        "status": true,
        "lastSyncedTimestamp": new Date(),
        "width": "150",
        "filter": true, "editable": true,
        "headerName": "Status",
        "sharedlistId": defaultStatusID,
        "defaultStatus": JSON.stringify({
            value: 'Backlog',
            parent: 'Default Status',
            precedence: '0:0',
            rowId: 'None',
        })
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 6",
        "field": "Column6",
        "headerName": "% Complete",
        "type": "number",
        "cellDataType": "number",
        "width": "120",
        "filter": true, "editable": true,
    },
    // Group 3 — Scheduling & Dependencies
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 7",
        "field": "Column7",
        "headerName": "Predecessor",
        "type": "predecessor",
        "width": "150",
        "linkedColumns": { "predecessorStartDate": "Column9", "predecessorEndDate": "Column10" },
        "filter": true, "editable": true,
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 8",
        "field": "Column8",
        "headerName": "Duration",
        "type": "duration",
        "width": "150",
        "linkedColumns": { "startDate": "Column9", "endDate": "Column10" },
        "filter": true, "editable": true,
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 9",
        "field": "Column9",
        "headerName": "Start Date",
        "type": "date",
        "rollup": "Min",
        "width": "150",
        "linkedColumns": { "endDate": "Column10", "duration": "Column8", "predecessor": "Column7", "predecessorEndDate": "Column10" },
        "filter": true, "editable": true,
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "Column 10",
        "field": "Column10",
        "headerName": "End Date",
        "type": "date",
        "rollup": "Max",
        "width": "150",
        "linkedColumns": { "startDate": "Column9", "duration": "Column8", "predecessor": "Column7", "predecessorStartDate": "Column9" },
        "filter": true, "editable": true,
    },
    // Group 4 — Reference & Baseline
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 11",
        "field": "Column11",
        "headerName": "Reference Plan",
        "type": "multi dimensional value",
        "width": "220",
        "filter": true, "editable": true,
        "listData": '[{"propName":"Ref Estimate","propType":"text","propAbbrevation":"RE","propId":"77ca760f-4595-4578-a056-659005dde56d"},{"propName":"Planned Start Date","propType":"date","propAbbrevation":"PSD","propId":"ccc7dafd-f39d-495f-a348-b79c56a9674e"},{"propName":"Planned End Date","propType":"date","propAbbrevation":"PED","propId":"283ec88e-791a-4e97-bb3b-94b13d1a3e5e"}]',
    },
    // Group 5 — Release & Sprint Tracking
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 12",
        "field": "Column12",
        "headerName": "Release #",
        "type": "text",
        "cellDataType": "text",
        "width": "120",
        "filter": true, "editable": true,
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 13",
        "field": "Column13",
        "headerName": "Sprint #",
        "type": "text",
        "cellDataType": "text",
        "width": "120",
        "filter": true, "editable": true,
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 14",
        "field": "Column14",
        "headerName": "Planned Release Sprint",
        "type": "text",
        "width": "180",
        "filter": true, "editable": true,
    },
    // Group 6 — Collaboration
    {
        "columnElasticid": `${uuidv4()}_es`,
        "colId": "Column 15",
        "field": "Column15",
        "headerName": "Comments",
        "type": "text",
        "width": "300",
        "filter": true, "editable": true,
    },
    ];
}
export const RollupListColumns=[
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "300",
        "colId": "#",
        "field": "#",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
         "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null, 
         "pivot": false, "pivotIndex": null, "aggFunc": null, "pinned": "left", "sort": null, "sortIndex": null, "rowDrag": true
    },
    {
        "columnElasticid": `${uuidv4()}_es`,
        "width": "400",
        "colId": "ag-Grid-AutoColumn",
        "field": "primaryCol",
        "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true, 
         "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null, 
         "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Status", 
         "suppressMovable": true, "lockPosition": true
    },
]